import AdManagementAdGroup1Reducer from 'store/ad-management-adgroup1/reducers';

export default AdManagementAdGroup1Reducer;
